/**
 * Use Reacts own error catching to catch and log errors with components
 */

import * as React from 'react';
import { ActionableErrorContext, Loggable, makeLog } from '../../utility/logger';
import { useIntl } from 'react-intl';

const ErrorScreen = ({ errorClickToFrontpage }: Pick<IOwnProps, 'errorClickToFrontpage'>) => {
  const { formatMessage } = useIntl();
  return (
    <div style={{ paddingLeft: '2rem' }}>
      <h2>{formatMessage({ id: 'general.error' })}</h2>
      <div>{formatMessage({ id: 'general.errorInfo' })}</div>
      {errorClickToFrontpage && (
        <div>
          {formatMessage(
            { id: 'general.errorClickToFrontpage' },
            {
              a: chunks => {
                return chunks.map((c, i) => (
                  <a href={'/'} key={`${c}${i}`}>
                    {c}
                  </a>
                )) as unknown as string;
              },
            },
          )}
        </div>
      )}
    </div>
  );
};

class ErrorContainer extends React.Component<IOwnProps, IOwnState> {
  state = {
    error: false,
  };

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    this.setState({ error: true });
    makeLog(Loggable.BugActionable, error, new ActionableErrorContext(info, 'render React component'));
  }

  public render(): React.JSX.Element | React.JSX.Element[] {
    const { errorClickToFrontpage = true } = this.props;

    return !this.state.error ? this.props.children : <ErrorScreen {...{ errorClickToFrontpage }} />;
  }
}

interface IOwnState {
  error: boolean;
}

interface IOwnProps {
  children: React.JSX.Element | React.JSX.Element[];
  errorClickToFrontpage?: boolean;
}

export default ErrorContainer;
